import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BufferOptionsItem from 'buffers/BufferOptionsItem';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import {InputChangeEvent} from 'util/Types';

export interface FindPrimersTabMenuProps {
  /** Whether the highlight-matching-bases checkbox should be checked */
  highlight: boolean;
  /** A function to be called when the highlight-matching-bases checkbox is changed */
  setHighlight: (highlightMatches: boolean) => void;
  /** Whether to show the Attach Selected Primers button */
  showSave: boolean;
  /** Whether to disable the Attach Selected Primers button */
  disableSave: boolean;
  /** A function to be called when the Attach Selected Primers button is clicked */
  addSelectedPrimers: () => Promise<void>;
}

export default function FindPrimersTabMenu({
  highlight,
  setHighlight,
  showSave,
  disableSave,
  addSelectedPrimers,
}: FindPrimersTabMenuProps): JSX.Element {
  return (
    <div className={`buffer-options-container ${css(styles.optionsBar)}`}>
      <BufferOptionsItem>
        <CheckboxInput
          onChange={(e: InputChangeEvent) => {
            setHighlight(e.target.checked);
          }}
          checked={highlight}
          id="highlight-matching-bases"
          label="Highlight matching bases"
        />
      </BufferOptionsItem>
      {showSave && (
        <BufferOptionsItem>
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            size={ButtonSize.MINI}
            onClick={addSelectedPrimers}
            disabled={disableSave}
            text="Attach Selected Primers"
            dataTestAttrs={{component: 'FindPrimersTabMenu', element: 'attachButton'}}
          />
        </BufferOptionsItem>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  optionsBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});
